
export default function GroupBoard(props) {
   
    return (
        <><div className="w-full sm:w-[24rem] flex flex-col items-start bg-transparent rounded-[2rem]  border-[0.4rem] border-primary p-[2rem]">
            <p className="text-center text-[24px] font-bakbak text-white mb-[2rem] self-center">GROUP {props?.list?.group}</p>
            <div>
            {props?.list?.listCompetitor.map((item, index) => (
                <div key={index} className="flex justify-start items-center last:mb-0 mb-[2rem]">
                    <div className="w-[6rem]  mr-[1.4rem]">
                        <img src={item.img} alt="" />
                    </div>
                    <p className="font-bakbak text-[16px] text-white">{item.name}</p>
                </div>
            ))}
            </div>
        </div></>
    )
}